import React, { useState } from "react";
import {
  Box,
  Heading,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Input,
  IconButton,
  Flex,
} from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";

interface FormElementProps {
  id: number;
  type: string;
  onDelete: (id: number) => void;
  setElements: React.Dispatch<React.SetStateAction<any[]>>;
  setOpenModel: any;
}

const FormElement: React.FC<FormElementProps> = ({
  id,
  type,
  onDelete,
  setOpenModel,
}) => {
  const renderElement = () => {
    switch (type) {
      case "heading":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Heading
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "paragraph":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Paragraph
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "text":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Text
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "number":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Number
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "date":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Date
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "email":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Email
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "select":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Select
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "textarea":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              TextArea
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "file":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              File
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "checkbox":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Checkbox
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "radio":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Radio
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "spacer":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Spacer
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "divider":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Divider
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "button":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Button
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      case "logo":
        return (
          <Flex
            height={"28px"}
            alignItems="center"
            justifyContent="space-between"
          >
            <Heading fontSize="small" color="gray">
              Logo
            </Heading>
            <IconButton
              size="xs"
              aria-label="Edit"
              onMouseDown={() => setOpenModel(id)}
              icon={<EditIcon />}
            />
          </Flex>
        );
      default:
        return null;
    }
  };

  return (
    <div
      style={{
        position: "relative",
        padding: "10px",
        border: "1px solid #ccc",
        cursor: "pointer",
      }}
    >
      {renderElement()}
    </div>
  );
};

export default FormElement;
